import { isArray, objectKeys, type ReadonlyRecord } from '../../../../../../utils'

import type { CybusDetailedCoreContainer, CybusDetailedServiceContainer } from '../../../../../../domain'

import { type BackendDefinition, mapToStatusType } from '../../../../../Connectware'
import { mapResourceNames } from '../../../../mappers'
import { safelyMapPlainProperties } from '../../../mappers'

export const mapDetailedCoreContainer = (
    id: string,
    name: string,
    container: BackendDefinition<'container-manager', 'ContainerResponse'>
): CybusDetailedCoreContainer => {
    const { Created, Mounts, Config, HostConfig } = container
    const { Image, WorkingDir, Labels, ExposedPorts = {}, Env } = Config

    return {
        id,
        name,
        created: Created ? new Date(Created) : null,
        volumes: [...Mounts].reduce<string[]>((volumes, v) => (v.Name ? [...volumes, v.Name] : volumes), []),
        status: mapToStatusType(container.State.Status?.toLowerCase()),
        config: {
            image: Image,
            workingDir: WorkingDir,
            author: Labels.author || null,
            vendor: Labels.vendor || null,
            capAdd: isArray(HostConfig.CapAdd) ? HostConfig.CapAdd.map(String) : HostConfig.CapAdd ? String(HostConfig.CapAdd) : null,
            exposedPorts: objectKeys<ReadonlyRecord<string, unknown>>(ExposedPorts),
            privileged: HostConfig.Privileged || false,
        },
        variables: safelyMapPlainProperties(
            Env.reduce<CybusDetailedCoreContainer['variables']>((r, variable) => {
                const [name, stringValue] = variable.split('=')
                return name === undefined || stringValue === undefined ? r : { ...r, [name]: stringValue }
            }, {})
        ),
    }
}

export const mapDetailedServiceContainer = (
    id: string,
    container: BackendDefinition<'container-manager', 'ContainerResponse'>
): CybusDetailedServiceContainer => {
    const [service, name] = mapResourceNames(id)
    return { ...mapDetailedCoreContainer(id, name, container), service }
}
